interface SvgProps {
  fill?: string;
}

const DropDownSvg = ({ fill = '#00AB6B' }: SvgProps) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 6L8.5 10L12.5 6"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DropDownSvg;
